import { axiosObject } from "../config";
import { webStore } from "store";
import { DateTime } from "luxon";

function createAuctionEvent(formData: any) {
  return new Promise((resolve, reject) => {
    const currentBank: any = webStore.getState().bankerAuth?.bank;
    const currentBranch: any = webStore.getState().bankerAuth?.currentBranch;
    const metaData = {
      dashboard_url: window.origin,
      approver: [
        { email: formData.approver.email, name: formData.approver.label },
      ],
      assigned_ao: {
        email: formData.assigned_ao?.label,
        name: formData.assigned_ao?.profile?.bio?.full_name
          ? formData.assigned_ao?.profile?.bio?.full_name
          : "",
      },
      bank_name: currentBank.name,
      branch_name: currentBranch.label,
    };

    const final_end_time_timestamp = DateTime.fromISO(
      formData.property_uuid.property?.auction_end_date_time,
    )
      .setZone("Asia/Kolkata")
      .toMillis();

    let uri = "auction/data/resource/events/_create";
    let payload = {
      property_uuid: formData.property_uuid.value,
      created_by: formData.created_by,
      event_name: formData.event_name,
      event_type: formData.event_type.value,
      assigned_ao: formData.assigned_ao?.value
        ? formData.assigned_ao?.value
        : "Banker",
      approver: formData.approver.value,
      signature_type: formData.signature_type.value,
      kyc_type: formData.kyc_type.value,
      auction_type: formData.auction_type.value,
      auction_currency: formData.auction_currency.value,
      possession_type: formData.possession_type.value,
      auto_extension: formData.auto_extension.value,
      extension_method: formData.extension_method.value,
      auto_extension_type: formData.auto_extension_type.value,
      auto_extension_limit:
        formData.auto_extension_type.value === "Unlimited"
          ? "Unlimited"
          : formData.auto_extension_limit,
      extend_time_at: formData.extend_time_at,
      extend_time_by: formData.extend_time_by,
      bidding_increment_amount: parseInt(formData.bidding_increment_amount),
      emd_payment_account_name: formData.emd_payment_account_name,
      emd_payment_account_number: formData.emd_payment_account_number,
      emd_payment_account_ifsc: formData.emd_payment_account_ifsc,
      emd_payment_account_bank: formData.emd_payment_account_bank,
      emd_payment_account_branch: formData.emd_payment_account_branch,
      emd_payment_method: formData.emd_payment_method.value,
      comment: formData.comment,
      borrower_name: formData.borrower_name,
      branch_uuid: currentBranch.value,
      bank_uuid: currentBank.uuid,
      meta: metaData,
      property_dump: formData.property_uuid.property,
      final_end_date: final_end_time_timestamp,
      start_date_time: formData.property_uuid.property?.auction_start_date_time,
      end_date_time: formData.property_uuid.property?.auction_end_date_time,
      reserve_price: formData.property_uuid.property?.reserve_price,
      final_price: formData.property_uuid.property?.reserve_price,
      bidding_type: formData.bidding_type.value,
      payment_validation_enabled:
        formData.enable_offline_payment_validation.value === "true"
          ? true
          : false,
      status: "accepted",
    };

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function updateAuctionEvent(
  formData: any,
  eventData: any,
  status: string,
  remark: string,
) {
  return new Promise((resolve, reject) => {
    const currentBank: any = webStore.getState().bankerAuth?.bank;
    const currentBranch: any = webStore.getState().bankerAuth?.currentBranch;
    let uri = "auction/data/resource/events/_patch";
    const final_end_time_timestamp = DateTime.fromISO(
      formData.property_uuid.property?.auction_end_date_time,
    )
      .setZone("Asia/Kolkata")
      .toMillis();

    const metaData = {
      dashboard_url: window.origin,
      approver: [
        { email: formData.approver.email, name: formData.approver.label },
      ],
      assigned_ao: {
        email: formData.assigned_ao?.label,
        name: formData.assigned_ao?.profile?.bio?.full_name
          ? formData.assigned_ao?.profile?.bio?.full_name
          : "Banker",
      },
      bank_name: currentBank.name,
      branch_name: currentBranch.label,
    };

    let payload: any = {
      uuid: eventData.uuid,
      property_uuid: formData.property_uuid.value,
      created_by: formData.created_by,
      event_name: formData.event_name,
      event_type: formData.event_type.value,
      assigned_ao: formData.assigned_ao?.value,
      approver: formData.approver.value,
      signature_type: formData.signature_type.value,
      kyc_type: formData.kyc_type.value,
      auction_type: formData.auction_type.value,
      auction_currency: formData.auction_currency.value,
      possession_type: formData.possession_type.value,
      auto_extension: formData.auto_extension.value,
      extension_method: formData.extension_method.value,
      auto_extension_type: formData.auto_extension_type.value,
      auto_extension_limit:
        formData.auto_extension_type.value === "Unlimited"
          ? "Unlimited"
          : formData.auto_extension_limit,
      extend_time_at: formData.extend_time_at,
      extend_time_by: formData.extend_time_by,
      bidding_increment_amount: parseInt(formData.bidding_increment_amount),
      emd_payment_account_name: formData.emd_payment_account_name,
      emd_payment_account_number: formData.emd_payment_account_number,
      emd_payment_account_ifsc: formData.emd_payment_account_ifsc,
      emd_payment_account_bank: formData.emd_payment_account_bank,
      emd_payment_account_branch: formData.emd_payment_account_branch,
      emd_payment_method: formData.emd_payment_method.value,
      comment: formData.comment,
      borrower_name: formData.borrower_name,
      branch_uuid: eventData.branch_uuid,
      bank_uuid: eventData.bank_uuid,
      meta: metaData,
      property_dump: formData.property_uuid.property,
      final_end_date: final_end_time_timestamp,
      start_date_time: formData.property_uuid.property?.auction_start_date_time,
      end_date_time: formData.property_uuid.property?.auction_end_date_time,
      reserve_price: formData.property_uuid.property?.reserve_price,
      final_price: formData.property_uuid.property?.reserve_price,
      bidding_type: formData.bidding_type.value,
      payment_validation_enabled:
        formData.enable_offline_payment_validation.value === "true"
          ? true
          : false,
    };

    if (status !== "") {
      payload["status"] = status;
    }

    if (remark !== "") {
      payload["comment"] = remark;
    }

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function deleteAuctionEvent(uuid: string) {
  return new Promise((resolve, reject) => {
    const uri = "auction/data/resource/events/_patch";

    const payload = {
      uuid: uuid,
      deleted_at: new Date().toISOString(),
    };

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function getAuctionEvents(startDate?: string, endDate?: string) {
  const currentBank: any = webStore.getState().bankerAuth?.bank;
  const currentBranch: any = webStore.getState().bankerAuth?.currentBranch;
  const status: any = [
    "accepted",
    "end",
    "pending",
    "rejected",
    "live",
    "failed",
    "success",
    "pending_bid_approval",
    "holding_bid_approval",
    "bid_rejected",
  ];

  return new Promise((resolve, reject) => {
    let uri = "auction/data/resource/events/_read";
    let payload = {
      apiConfig: {
        includeRelations: "*",
      },
      limitBy: {
        per_page: 50,
        page: 1,
      },
      sortBy: [
        {
          attribute: "created_at",
          order: "desc",
        },
      ],
      filterBy: [
        {
          attribute: "branch_uuid",
          op: "eq",
          value: currentBranch && currentBranch.value,
        },
        {
          attribute: "bank_uuid",
          op: "eq",
          value: currentBank && currentBank.uuid,
        },
        {
          attribute: "status",
          op: "in",
          value: status,
        },
      ],
    };
    if (startDate) {
      payload.filterBy.push({
        attribute: "start_date_time",
        op: "gte",
        value: startDate,
      });
    }

    if (endDate) {
      payload.filterBy.push({
        attribute: "end_date_time",
        op: "lte",
        value: endDate,
      });
    }
    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}
function getSwissAuctionEvents(
  relation = true,
  parPageLimit = 50,
  onlySwiss = false,
) {
  const currentBank: any = webStore.getState().bankerAuth?.bank;
  const currentBranch: any = webStore.getState().bankerAuth?.currentBranch;
  const status: any = [
    "accepted",
    "end",
    "pending",
    "rejected",
    "live",
    "pending_bid_approval",
  ];

  return new Promise((resolve, reject) => {
    let uri = "auction/data/resource/events/_read";
    let payload: any = {
      sortBy: [
        {
          attribute: "created_at",
          order: "desc",
        },
      ],
      filterBy: [
        {
          attribute: "branch_uuid",
          op: "eq",
          value: currentBranch && currentBranch.value,
        },
        {
          attribute: "bank_uuid",
          op: "eq",
          value: currentBank && currentBank.uuid,
        },
        // {
        //   attribute: "status",
        //   op: "in",
        //   value: status,
        // },
      ],
    };
    if (onlySwiss) {
      payload.filterBy.push({
        attribute: "event_type",
        op: "in",
        value: ["Asset transfer"],
      });
    } else {
      payload.filterBy.push({
        attribute: "event_type",
        op: "in",
        value: ["Private", "Sarfaesi", "DRT", "IBC"],
      });
    }
    if (relation) {
      payload["apiConfig"] = {
        includeRelations: "*",
        includeMutations: "*",
      };
    }
    if (parPageLimit) {
      payload["limitBy"] = {
        per_page: parPageLimit,
        page: 1,
      };
    } else {
      payload["limitBy"] = {
        per_page: 999,
        page: 1,
      };
    }
    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function getAuctionEventById(id: any) {
  return new Promise((resolve, reject) => {
    let uri = "auction/data/resource/events/_read";
    let payload = {
      apiConfig: {
        includeRelations: "*",
        includeMutations: "*",
      },
      limitBy: {
        per_page: 10,
        page: 1,
      },
      sortBy: [],
      filterBy: [
        {
          attribute: "listing_id",
          op: "eq",
          value: id,
        },
      ],
    };

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data.data[0]);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function getAuctionEventByUuid(id: any) {
  return new Promise((resolve, reject) => {
    let uri =
      process.env.NEXT_PUBLIC_APP_NAME === "admin"
        ? "/data/resource/events/_read"
        : "auction/data/resource/events/_read";

    let payload = {
      apiConfig: {
        includeRelations: "*",
        includeMutations: "*",
      },
      limitBy: {
        per_page: 10,
        page: 1,
      },
      sortBy: [],
      filterBy: [
        {
          attribute: "uuid",
          op: "eq",
          value: id,
        },
      ],
    };

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data.data[0]);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function getAuctionEventByUuid_AuctionFloor(id: any) {
  return new Promise((resolve, reject) => {
    let uri =
      process.env.NEXT_PUBLIC_APP_NAME === "admin"
        ? "/data/resource/events/_read"
        : "auction-floor/data/resource/events/_read";

    let payload = {
      apiConfig: {
        includeRelations: "*",
        includeMutations: "*",
      },
      limitBy: {
        per_page: 10,
        page: 1,
      },
      sortBy: [],
      filterBy: [
        {
          attribute: "uuid",
          op: "eq",
          value: id,
        },
      ],
    };

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data.data[0]);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function updateAuctionEventStatus(
  event_uuid: string,
  status: string,
  cancellation_reason: string,
) {
  return new Promise((resolve, reject) => {
    let uri = "auction/data/resource/events/_patch";
    let payload: any = {
      uuid: event_uuid,
      status: status,
    };
    if (status === "cancelled")
      payload["cancellation_reason"] = cancellation_reason;
    else payload["comment"] = cancellation_reason;

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}
function updateAuctionEventStatus_AuctionFloor(
  event_uuid: string,
  status: string,
  cancellation_reason: string,
) {
  return new Promise((resolve, reject) => {
    let uri = "auction-floor/data/resource/events/_patch";
    let payload: any = {
      uuid: event_uuid,
      status: status,
    };
    if (status === "cancelled")
      payload["cancellation_reason"] = cancellation_reason;
    else payload["comment"] = cancellation_reason;

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function updateSaleCert25Generated(event_uuid: string, value: boolean) {
  return new Promise((resolve, reject) => {
    let uri = "auction/data/resource/events/_patch";
    let payload: any = {
      uuid: event_uuid,
      sale_cert_25_generated: value,
    };

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function updateSaleCert100Generated(event_uuid: string, value: boolean) {
  return new Promise((resolve, reject) => {
    let uri = "auction/data/resource/events/_patch";
    let payload: any = {
      uuid: event_uuid,
      sale_cert_100_generated: value,
    };

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function getAllAuctionEvents(
  status: any,
  startDate?: any | null,
  endDate?: any | null,
  limitBy?: any | null,
  page?: number,
  search?: string | null,
) {
  return new Promise((resolve, reject) => {
    let uri = "auction/data/resource/events/_read";
    let payload = {
      apiConfig: {
        includeRelations: "*",
        includeMutations: "*",
      },
      limitBy: {
        per_page: 10,
        page: page || 1,
      },
      sortBy: [
        {
          attribute: "start_date_time",
          order: "asc",
        },
      ],
      filterBy: [
        {
          attribute: "status",
          op: "in",
          value: status,
        },
        {
          attribute: "event_type",
          op: "in",
          value: ["Private", "Sarfaesi", "DRT", "IBC"],
        },
      ],
    };
    if (startDate) {
      payload.filterBy.push({
        attribute: "start_date_time",
        op: "gte",
        value: startDate,
      });
    }

    if (endDate) {
      payload.filterBy.push({
        attribute: "end_date_time",
        op: "lte",
        value: endDate,
      });
    }
    if (limitBy) {
      payload.limitBy = limitBy;
    }

    // Search filter: filter by listing_id, borrower_name, or bank name
    // Backend expects: listing_id (eq), borrower_name (ilike), bank (ilike)
    if (search && typeof search === "string" && search.trim() !== "") {
      const searchValue = search.trim();
      // Check if search is numeric (likely listing_id)
      if (/^\d+$/.test(searchValue)) {
        // Exact match for numeric search (listing_id)
        payload.filterBy.push({
          attribute: "listing_id",
          op: "eq",
          value: searchValue,
        });
      } else {
        // ILIKE search for non-numeric (borrower_name or bank name)
        payload.filterBy.push({
          attribute: "borrower_name",
          op: "ilike",
          value: searchValue,
        });
        payload.filterBy.push({
          attribute: "bank",
          op: "ilike",
          value: searchValue,
        });
      }
    }

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}
function getAllAuctionEventsCount(status: any) {
  return new Promise((resolve, reject) => {
    let uri = "auction/events-count";
    let payload = {
      status: status,
    };
    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function getAllAuctionForAdmin(status: any) {
  return new Promise((resolve, reject) => {
    let uri = "/data/resource/events/_read";
    let payload = {
      apiConfig: {
        includeRelations: "*",
        includeMutations: "*",
      },
      limitBy: {
        per_page: 999,
        page: 1,
      },
      sortBy: [
        {
          attribute: "created_at",
          order: "desc",
        },
      ],
      filterBy: [
        {
          attribute: "status",
          op: "in",
          value: status,
        },
      ],
    };
    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}
function getAllAuctionForAdminMonthly(
  status: any,
  year: number,
  month: number,
) {
  return new Promise((resolve, reject) => {
    let uri = "/data/resource/events/_read";

    // Calculate start and end dates for the month
    const startDate = new Date(year, month - 1, 1); // month is 0-indexed in JS
    const endDate = new Date(year, month, 0, 23, 59, 59, 999); // Last day of the month

    let payload = {
      apiConfig: {
        includeRelations: "*",
      },
      limitBy: {
        per_page: 999,
        page: 1,
      },
      filterBy: [
        {
          attribute: "status",
          op: "in",
          value: status,
        },
        {
          attribute: "start_date_time",
          op: "gte",
          value: startDate.toISOString(),
        },
        {
          attribute: "start_date_time",
          op: "lte",
          value: endDate.toISOString(),
        },
      ],
    };
    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function getAuctionEventsForBidder(
  ids: any,
  status: any,
  withRelations: boolean = true,
) {
  return new Promise((resolve, reject) => {
    let uri = "auction/data/resource/events/_read";
    let payload = {
      apiConfig: withRelations
        ? {
            includeRelations: "*",
            includeMutations: "*",
          }
        : undefined,
      limitBy: {
        per_page: 50,
        page: 1,
      },
      sortBy: [
        {
          attribute: "start_date_time",
          order: "desc",
        },
      ],
      filterBy: [
        {
          attribute: "uuid",
          op: "in",
          value: ids,
        },
        {
          attribute: "status",
          op: "in",
          value: status,
        },
      ],
    };
    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}
function getAuctionEventsForBidderHome(ids: any, status: any) {
  return new Promise((resolve, reject) => {
    let uri = "auction/data/resource/events/_read";
    let payload = {
      apiConfig: {
        includeRelations: "*",
        includeMutations: "*",
      },
      limitBy: {
        per_page: 50,
        page: 1,
      },
      sortBy: [
        {
          attribute: "start_date_time",
          order: "asc",
        },
      ],
      filterBy: [
        {
          attribute: "uuid",
          op: "in",
          value: ids,
        },
        {
          attribute: "status",
          op: "in",
          value: status,
        },
      ],
    };

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function getAuctionEventsWithPagination(data: any) {
  const currentBank: any = webStore.getState().bankerAuth?.bank;
  const currentBranch: any = webStore.getState().bankerAuth?.currentBranch;

  return new Promise((resolve, reject) => {
    let uri = "auction/data/resource/events/_read";
    const defaultEventTypes = ["Private", "Sarfaesi", "DRT", "IBC"];
    const eventTypes =
      Array.isArray(data?.eventTypes) && data.eventTypes.length > 0
        ? data.eventTypes
        : defaultEventTypes;
    const filterBy = [
      {
        attribute: "branch_uuid",
        op: "eq",
        value: currentBranch && currentBranch.value,
      },
      {
        attribute: "bank_uuid",
        op: "eq",
        value: currentBank && currentBank.uuid,
      },
      {
        attribute: "event_type",
        op: "in",
        value: eventTypes,
      },
    ];

    if (data.status) {
      filterBy.push({
        attribute: "status",
        op: "eq",
        value: data.status,
      });
    }

    if (data.startDate) {
      filterBy.push({
        attribute: "start_date_time",
        op: "gte",
        value: data.startDate,
      });
    }

    if (data.endDate) {
      filterBy.push({
        attribute: "end_date_time",
        op: "lte",
        value: data.endDate,
      });
    }

    if (data.searchQuery) {
      if (/^\d+$/.test(data.searchQuery)) {
        filterBy.push({
          attribute: "listing_id",
          op: "like",
          value: data.searchQuery,
        });
      } else {
        filterBy.push({
          attribute: "borrower_name",
          op: "like",
          value: data.searchQuery,
        });
      }
    }

    const limitBy = {
      per_page: 50,
      page: data?.page ? data?.page : "1",
    };

    let payload = {
      apiConfig: {
        includeRelations: "*",
        includeMutations: "*",
      },
      limitBy: limitBy,
      sortBy: [
        {
          attribute: "created_at",
          order: "desc",
        },
      ],
      filterBy: filterBy,
    };
    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function getEventsWithinDateRange(data: any) {
  const currentBank: any = webStore.getState().bankerAuth?.bank;
  const currentBranch: any = webStore.getState().bankerAuth?.currentBranch;

  return new Promise((resolve, reject) => {
    let uri = "auction/data/resource/events/_read";
    const filterBy = [
      {
        attribute: "branch_uuid",
        op: "eq",
        value: currentBranch && currentBranch.value,
      },
      {
        attribute: "bank_uuid",
        op: "eq",
        value: currentBank && currentBank.uuid,
      },
      {
        attribute: "deleted_at",
        op: "is",
        value: null,
      },
    ];

    if (data.status && data?.status?.length > 0) {
      filterBy.push({
        attribute: "status",
        op: "in",
        value: data.status,
      });
    }

    if (data.startDate) {
      filterBy.push({
        attribute: "start_date_time",
        op: "gte",
        value: data.startDate,
      });
    }

    if (data.endDate) {
      filterBy.push({
        attribute: "end_date_time",
        op: "lte",
        value: data.endDate,
      });
    }
    let payload = {
      apiConfig: {
        includeRelations: "*",
        includeMutations: "*",
      },
      sortBy: [
        {
          attribute: "created_at",
          order: "desc",
        },
      ],
      filterBy: filterBy,
      limitBy: {
        per_page: 999,
        page: 1,
      },
    };
    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function getBankerDashboardEventsCount(data: any) {
  const currentBank: any = webStore.getState().bankerAuth?.bank;
  const currentBranch: any = webStore.getState().bankerAuth?.currentBranch;

  return new Promise((resolve, reject) => {
    let uri = "auction/banker-homepage-data";
    let payload = {
      branch_uuid: currentBranch && currentBranch.value,
      bank_uuid: currentBank && currentBank.uuid,
      start_date_time: data?.startDate,
      end_date_time: data?.endDate,
      type: data?.type,
    };

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}
function getAuctionEventStatusById(id: any) {
  return new Promise((resolve, reject) => {
    let uri = `auction/event-status/${id}`;
    axiosObject
      .get(uri)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function getAuctionEventStatusById_AuctionFloor(id: any) {
  return new Promise((resolve, reject) => {
    let uri = `auction-floor/event-status/${id}`;
    axiosObject
      .get(uri)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function sendEventAnnouncement(payload: any) {
  return new Promise((resolve, reject) => {
    let uri = `auction/send-announcement`;
    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}
function sendEventAnnouncement_AuctionFloor(payload: any) {
  return new Promise((resolve, reject) => {
    let uri = `auction-floor/send-announcement`;
    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}
function getAllEventAnnouncements(eventUuid: string) {
  return new Promise((resolve, reject) => {
    let uri = "auction/data/resource/event-announcements/_read";
    const filterBy = [
      {
        attribute: "event_uuid",
        op: "eq",
        value: eventUuid,
      },
    ];
    const limitBy = {
      per_page: 500,
      page: "1",
    };

    let payload = {
      apiConfig: {
        includeRelations: "*",
        includeMutations: "*",
      },
      limitBy: limitBy,
      sortBy: [
        {
          attribute: "created_at",
          order: "desc",
        },
      ],
      filterBy: filterBy,
    };
    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

export {
  createAuctionEvent,
  updateAuctionEvent,
  getAuctionEvents,
  getAuctionEventById,
  getAuctionEventByUuid,
  getAuctionEventByUuid_AuctionFloor,
  updateAuctionEventStatus,
  updateAuctionEventStatus_AuctionFloor,
  updateSaleCert25Generated,
  updateSaleCert100Generated,
  getAllAuctionEvents,
  getAuctionEventsForBidder,
  getAuctionEventsForBidderHome,
  getAllAuctionForAdmin,
  getAllAuctionForAdminMonthly,
  getAuctionEventsWithPagination,
  getAuctionEventStatusById,
  getAuctionEventStatusById_AuctionFloor,
  sendEventAnnouncement,
  sendEventAnnouncement_AuctionFloor,
  getEventsWithinDateRange,
  deleteAuctionEvent,
  getAllEventAnnouncements,
  getAllAuctionEventsCount,
  getBankerDashboardEventsCount,
  getSwissAuctionEvents,
};
